var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAskToJoin = function SvgAskToJoin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 16",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.806 16q-1.817 0-3.091-1.008t-1.826-2.425L.217 8.25q-.308-.8-.179-1.192.13-.39.585-.391.6 0 .941.358.34.359.552.908l.714 1.884q.015.05.26.183h.227V2.2q0-.35.251-.608a.8.8 0 0 1 1.177 0 .86.86 0 0 1 .244.608v5.467q0 .133.097.233a.307.307 0 0 0 .454 0 .32.32 0 0 0 .098-.233v-6.8q0-.35.251-.609A.8.8 0 0 1 6.482 0a.8.8 0 0 1 .592.258.84.84 0 0 1 .252.609v6.8q0 .133.097.233a.307.307 0 0 0 .455 0 .32.32 0 0 0 .097-.233v-5.8q0-.35.252-.609A.8.8 0 0 1 8.819 1a.8.8 0 0 1 .592.258.84.84 0 0 1 .252.609v5.8q0 .133.097.233a.307.307 0 0 0 .455 0 .32.32 0 0 0 .097-.233v-3.8q0-.35.252-.609A.8.8 0 0 1 11.156 3a.8.8 0 0 1 .592.258.84.84 0 0 1 .252.609v6.966q0 2.284-1.485 3.725Q9.03 16.001 6.806 16"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAskToJoin);
export { ForwardRef as Icon };
export default "img/element-icons/ask-to-join.a351162.svg";